interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** true: 절대 위치 오버레이 (부모에 relative 필요) */
  overlay?: boolean
  /** true: 화면 전체를 덮는 풀스크린 오버레이 */
  fullscreen?: boolean
}

const sizeMap = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
}

const SpinnerIcon = ({ size, className }: { size: 'sm' | 'md' | 'lg'; className?: string }) => (
  <div
    role="status"
    aria-label="로딩 중"
    className={[
      'animate-spin rounded-full border-white/20 border-t-white',
      sizeMap[size],
      className ?? '',
    ].join(' ')}
  />
)

export const Spinner = ({ size = 'md', className, overlay, fullscreen }: SpinnerProps) => {
  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
        <SpinnerIcon size={size} />
      </div>
    )
  }

  if (overlay) {
    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/60">
        <SpinnerIcon size={size} />
      </div>
    )
  }

  return <SpinnerIcon size={size} className={className} />
}
